import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  ecWrapper: {
    "& .ec-header-wrapper": {
      padding: "15px 30px",
      display: "flex",
      position: "static",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: "1px solid var(--blackOpacity10)",

      "& .ant-image": {
        borderRadius: "5px",
        objectFit: "cover",
      },
      "& .basket-icon": {
        position: "relative",
        "& svg": {
          width: "30px",
          height: "100%",
          marginLeft: "30px",
          cursor: "pointer",
        },
      },
      "& .basket-icon.active .ePNum": {
        position: "absolute",
        bottom: "0",
        right: "0",
        backgroundColor: "var(--primary)",
        padding: "3px 6px",
        color: "#fff",
        fontSize: "10px",
        borderRadius: "50%",
        fontWeight: "bold",
        textShadow: "1px 1px 1px #00000070",
      },
      "& .basket-icon.active svg path": {
        fill: "var(--primary)",
      },
      "& .ec-header-wrapper-right": {
        alignItems: "center",
        display: "flex",
        "& .dropDown": {
          backgroundColor: "var(--light)",
          padding: "10px",
          borderRadius: "5px",
          "& .dropDown svg": {
            width: "13px",
            transition: "0.3s all ease-in-out",
            margin: "0",
          },
          "& .subInnerHeading": {
            marginBottom: "0",
            fontSize: "16px",
          },
          "& .dropDown svg path": {
            fill: "var(--dark)",
          },
          "& .cross-icon svg": { width: "20px", height: "100%" },
        },
      },
    },
    "& .chainList .ant-dropdown-menu-title-content p": { fontSize: "16px" },
    "& .ec-front-wrapper": { textAlign: "center" },
    "& .ec-footer-wrapper": {
      padding: "10px 0",
      textAlign: "center",
      "& svg": { width: "150px" },
      "& p": {
        fontSize: "12px",
        fontWeight: 600,
        color: "var(--dark)",
      },
    },
    "& .ecProduct": {
      "& .homebg": {
        height: "calc(100vh - 72px)",
        width: "100%",
        position: "relative",
      },
      "& .ant-image": {
        width: "100%",
        height: "100%",
        objectFit: "cover",
      },

      "& .homebg .ant-image img": {
        filter: "brightness(0.6)",
        width: "100%",
        height: "100%",
        padding: "0",
        objectFit: "cover",
      },
      "& .ec-front-content": {
        position: "absolute",
        top: "50%",
        left: "400px",
        transform: "translate(-50%, -50%)",
        textAlign: "left",

        "& h1": {
          color: "var(--white) !important",
          fontSize: "50px",
          margin: "0 0 30px",
          letterSpacing: "1px",
          fontWeight: 600,
        },
        "& h1,\n.ec-front-content p": {
          textAlign: "left",
          color: "var(--white)",
        },
        "& p": {
          margin: "0 0 50px",
          color: "var(--light) !important",
          fontSize: "20px",
          lineHeight: "32px",
          fontStyle: "italic",
          fontWeight: 400,
          width: "100%",
          maxWidth: "650px",
          letterSpacing: "0.5px",
        },
        "& button": { textAlign: "left" },
        "& svg": { transform: "rotate(180deg)", marginLeft: "10px" },
        "& svg path": {
          fill: "var(--white)",
          transition: "0.2s all ease-in-out",
        },
        "& .ecCommonButton": {
          padding: "15px 70px",
          borderRadius: "5px",
          backgroundColor: "var(--primary)",
          color: "var(--white)",
          fontSize: "18px",
          fontWeight: 600,
          lineHeight: "normal",
          border: "2px solid transparent",
          transition: "0.2s all ease-in-out",
          cursor: "pointer",
        },
        "& .ecCommonButton:hover": {
          color: "var(--primary) !important",
          backgroundColor: "transparent !important",
          border: "2px solid var(--primary) !important",
        },
        "& .ecCommonButton:hover svg path": { fill: "var(--primary)" },
      },
      "& .productWrapper": {
        height: "unset",
        paddingBottom: "30px",
      },
    },
    "& .ecProduct .productHeader": { display: "none" },
    "& .ecContainer": { maxWidth: "1320px", margin: "0 auto" },
    "& .ecProduct .productListWrapper": { boxShadow: "none", paddingTop: "0" },
    "& .ecProduct .productListContent .subInnerHeadingPara": {
      color: "var(--dark)",
      fontWeight: 600,
    },
    "& .ecProduct .productListContent .productInfo": {
      color: "var(--grey)",
      marginBottom: "10px",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "22px",
    },
    "& .ecProduct .productListBody": {
      height: "unset",
      minHeight: "unset",
      maxHeight: "unset",
      paddingTop: "0",
    },
    "& .ecTabs": {
      width: "100%",
      color: "var(--dark)",
      backgroundColor: "var(--light)",
    },
    "& .ecTabs .ecTabsInner": {
      margin: "0 auto",
      maxWidth: "700px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "5px 0",
    },
    "& .ecTabs .ecTabsInner .categoryTabs": {
      padding: "10px 50px",
      cursor: "pointer",
      borderRadius: "5px",
    },
    "& .ecTabs .ecTabsInner .categoryTabs p": {
      color: "var(--dark)",
      margin: "0",
    },
    "& .ecTabs .ecTabsInner .categoryTabs.active": {
      backgroundColor: "var(--dark)",
    },
    "& .ecTabs .ecTabsInner .categoryTabs.active p": { color: "var(--white)" },
    "& .ecProduct .productWrapper": { height: "unset", paddingBottom: "30px" },
    "& .productHeadingWrapper": {
      textAlign: "center",
      padding: "30px 0",
      textTransform: "capitalize",
    },
    "& .productListWrapper": {
      width: "100%",
      padding: "10px",
      overflowY: "auto",
      borderRadius: "10px",
      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",

      "& .productListHeader input": {
        maxWidth: "600px",
        width: "100%",
        borderColor: "rgb(3, 3, 3, 0.3)",
        margin: "0 30px",
      },
      "& .productListHeader .searchIcon": { display: "none" },
      "& .productListHeader .mainHeading": { marginBottom: "0" },
      "& .productListHeader svg": {
        height: "100%",
        width: "25px",
      },
      "& .productListBody": {
        paddingTop: "30px",
        display: "flex",
        flexWrap: "wrap",
        marginLeft: "-10px",
        marginRight: "-10px",
        minHeight: "calc(100vh - 135px)",
        overflow: "auto",
        alignContent: "flex-start",

        "& .productListBottom": {
          display: "flex",
          justifyContent: "space-between",
          marginTop: "auto",
          alignItems: "center",
          gap: "15px",
        },
        "& .productListBottom .commonButtonSmall": {
          padding: "7px 14px",
          fontSize: "15px",
          backgroundColor: "var(--primary)",
          borderWidth: "1px",
        },
        "& .productListBottom .commonButtonSmall:hover": {
          color: "var(--primary) !important",
          borderColor: "var(--primary) !important",
          borderWidth: "1px !important",
        },
        "& .productListBottom .commonButtonSmall:disabled": {
          backgroundColor: "var(--grey) !important",
          pointerEvents: "none",
          opacity: 0.5,
        },
        "& .productListBottom .commonButtonSmall.remove": {
          color: "var(--danger) !important",
          borderColor: "var(--danger) !important",
          borderWidth: "1px !important",
          backgroundColor: "transparent !important",
        },
        "& .productListBottom .commonButtonSmall.remove:hover": {
          color: "var(--white) !important",
          backgroundColor: "var(--danger) !important",
        },
      },
    },
    "& .productListHeader": {
      paddingBottom: "30px",
      borderBottom: "1px solid var(--blackOpacity10)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    "& .productItemWrapper": {
      flex: "0 0 33.33%",
      maxWidth: "33.33%",
      paddingLeft: "10px",
      paddingRight: "10px",
      marginBottom: "20px",
    },
    "& .productItemInner": {
      borderRadius: "10px",
      height: "100%",
      padding: "15px",
      display: "flex",
      flexDirection: "column",
      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    },
    ".subCatListWrapper": {
      marginTop: "0.5rem",
      marginRight: "0.5rem",
      textAlign: "center",
    },
    ".subCatListWrapper .productListImage": { width: "150px !important" },
    "& .productListImage": {
      width: "100%",
      height: "150px",
      backgroundColor: "var(--light)",
      borderRadius: "10px",
    },
    "& .productListImage img": {
      width: "100%",
      height: "100%",
      objectFit: "contain",
      borderRadius: "10px",
    },
    "& .productListContent .subInnerHeadingPara": {
      margin: "15px 0 10px",
      fontSize: "18px",
      textTransform: "capitalize",
    },
    "& .productItemWrapper .subInnerHeading": { marginBottom: "0" },
  },
});
